export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.ttf?c6a0c95b0a95c4553700768802e10f98";